import React, { memo } from 'react';

import { areEqual } from 'Utils/equalityChecks';

import { DamageTypeButton } from 'Components/RocketScan';

import classes from './selectDamageTypeScreen.module.css';

interface Props {
  onClick: (e: any) => void;
}

function SelectDamageTypeScreen({ onClick }: Props) {
  return (
    <div className={classes.container}>
      <DamageTypeButton
        id={1}
        caption="Carpentry"
        onButtonClick={() => {
          onClick('Carpentry');
        }}
      />
      <DamageTypeButton
        id={2}
        caption="Ceiling"
        onButtonClick={() => {
          onClick('Ceiling');
        }}
      />
      <DamageTypeButton
        id={3}
        caption="Flooring"
        onButtonClick={() => {
          onClick('Flooring');
        }}
      />
      <DamageTypeButton
        id={4}
        caption="Plumbing"
        onButtonClick={() => {
          onClick('Plumbing');
        }}
      />
      <DamageTypeButton
        id={5}
        caption="Walls"
        onButtonClick={() => {
          onClick('Walls');
        }}
      />
    </div>
  );
}

const SelectDamageTypeScreenMemo = memo(SelectDamageTypeScreen, areEqual);
export { SelectDamageTypeScreenMemo as SelectDamageTypeScreen };
